import { render, staticRenderFns } from "./TheDappSubmissionLayout.vue?vue&type=template&id=71bd783d&scoped=true&"
import script from "./TheDappSubmissionLayout.vue?vue&type=script&lang=js&"
export * from "./TheDappSubmissionLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheDappSubmissionLayout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TheDappSubmissionLayout.vue?vue&type=style&index=1&id=71bd783d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd783d",
  null
  
)

export default component.exports